<template>
  <div class="container-fluid mt-2">
    <div role="toolbar" class="btn-toolbar">
      <div class="btn-group mr-3 mb-3">
        <button @click="save()" class="btn btn-primary"><font-awesome-icon icon="save"/>&nbsp;Speichern</button>
      </div>
    </div>
    <div class="container-fluid mt-2" style="height:600px;">
      <div class="row">
        <div class="col-md">
          <AceEditor ref="gceditor" :editorId='"gcparamseditor"' lang="javascript" :content="config['giftcard.params.readme']"/>
        </div>
        <div class="col-md">
          <iframe style="width:100%;height:500px;border: none;" :src="baseurl + 'help/giftcards/gcparams.html'">
          </iframe>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from '@/modules/config.js'
import AceEditor from '@/components/AceEditor.vue'

export default {
  name: 'GiftCardConfig',
  components: {
    AceEditor,
  },
  data() {
    return {
      baseurl: config.baseUrl,
      needs: ["giftcard.params.readme"],
      config: {}
    }
  },
  created: function() {
    var self = this;
    config.loadcfg(this.needs,this,function(data) {
      self.config = data;
    })
  },
  methods: {
    save: function() {
      var self = this;
      this.config['giftcard.params.readme'] = this.$refs.gceditor.getContent();
      config.savecfg(this.config,this,function() {
        self.$bvToast.toast('Konfiguration gespeichert',{title:'E-Mail',variant: 'success'});
      })
    }
  }
}
</script>
